import React, { useMemo } from 'react';
import { Container, Sprite, Text } from '@pixi/react';

import { applicationStore } from '../../../store/applicationStore';
import { connectionPopupStore } from '../../../store/connectionPopupStore';

import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';

import Button from '../../common/button';

function InsufficientAmount() {
  const { sessionExpiredIcon } = useMemo(() => {
    return getGameImages();
  }, []);

  return (
    <Container>
      <Sprite texture={sessionExpiredIcon} x={isMobile() ? 169 : 157} y={8} />
      <Text
        x={186}
        y={95}
        anchor={0.5}
        text={applicationStore.canvasTranslationKeys.INSUFFICIENT_FUNDS}
        style={{
          _fontSize: 16,
          _fontWeight: 500,
          _fontFamily: 'poppinsMedium',
          _fill: '#FFFFFF',
          align: 'center',
          _wordWrap: true,
          _wordWrapWidth: 206,
        }}
        resolution={2}
      />
      <Button
        x={186}
        y={162}
        buttonText={applicationStore.canvasTranslationKeys.OK}
        textStyles={{
          _fontSize: 20,
          _fontWeight: 500,
          _fill: '#FFFFFF',
          _fontFamily: 'poppinsMedium',
        }}
        handleClickButton={() => {
          connectionPopupStore.close();
          applicationStore.setIsShowBlackLayer(false);
        }}
      />
    </Container>
  );
}
export default InsufficientAmount;
